export default "__VITE_ASSET__soTEzrm6__"